import React, { ReactElement } from 'react';

import { Button, Typography } from '@/shared/components/atoms';

interface FallbackProps {
  error: Error;
  // componentStack: string | null;
  // eventId: string | null;
  resetError(): void;
}

// TODO : refactore this component
export default function ErrorFallback({
  error,
  // componentStack,
  resetError,
}: FallbackProps): ReactElement {
  return (
    <div className='flex h-screen  flex-col items-center justify-center gap-16 text-center'>
      <Typography variant='subtitle1' className='text-error-default'>
        Sorry, something went wrong.
      </Typography>
      <Typography className='text-error-400' variant='body2'>
        {error.toString()}
      </Typography>
      <div className='flex items-center '>
        <Button
          key='reset'
          onClick={() => {
            resetError();
          }}
        >
          Click here to reset!
        </Button>

        <Button variant='text' key='back' onClick={() => window.history.back()}>
          Back
        </Button>
      </div>
    </div>
  );
}
